import { MatchingMeetingTypeRequest } from '@ent-regis/entregis-ts-angular/model/matchingMeetingTypeRequest';

export const MeetingType = [
    { type: MatchingMeetingTypeRequest.MatchingMeetingTypeEnum.GROUP, label: 'Group' },
    { type: MatchingMeetingTypeRequest.MatchingMeetingTypeEnum.SMALLGROUP, label: 'Small Group (maximum 5)' },
    { type: MatchingMeetingTypeRequest.MatchingMeetingTypeEnum.ONEONONE, label: '1 on 1' },
    { type: MatchingMeetingTypeRequest.MatchingMeetingTypeEnum.DIALIN, label: 'Dial-in' },
    { type: MatchingMeetingTypeRequest.MatchingMeetingTypeEnum.VIRTUALGROUP, label: 'Virtual (Group)' }
  ];
